import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
}

export const TITHELY_FORM_ID = 'bd9e646f-97f2-4ecc-990e-94c9cdb1cef9';

export const siteInfo = {
  name: 'Holy Temple Cobbtown Community Church',
  shortName: 'Holy Temple CCC',
  address: {
    street: '1687 Jr Collins Rd',
    city: 'Cobbtown',
    state: 'Georgia',
    zip: '30420'
  },
  serviceTime: 'Sundays at 12:00 PM',
  email: 'info@HolyTempleCCC.org',
  phone: '912-237-4771',
  social: {
    facebook: 'https://facebook.com/holytempleccc'
  },
  giving: {
    cashApp: '$HolyTempleCCCGiver',
    venmo: 'Info@HolyTempleCCC.org'
  }
};
